import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deepEqual } from 'fast-equals';
import queryString from 'query-string';

import { firePixelServer } from 'actions/pixelServer';
import { fetchOrders } from 'actions/account/orders';
import { checkCustomerAuthentication } from 'actions/authentication';
import { PageLoader } from 'components/Loader';
import BackNav from 'components/account/BackNav';
import Breadcrumb from 'components/account/Breadcrumb';
import AccountHeader from 'containers/account/AccountHeader';
import OrderHistoryOverview from 'components/account/OrderHistoryOverview/OrderHistoryOverview';
import OrderHistoryCardLayout from 'components/account/OrderHistoryCardLayout';
import styles from 'styles/containers/account/orderHistory.scss';

const items = [{ name: 'Order History' }];

/* mobile MyAccount -> View Order History */
export class OrderHistory extends Component {
  componentDidMount() {
    const { firePixelServer, checkCustomerAuthentication } = this.props;
    const returnTo = '/orders';

    checkCustomerAuthentication(returnTo, () => this.fetchData());
    firePixelServer('order-history');
  }

  componentDidUpdate(prevProps) {
    const { location: { search: prevSearch }, fetchOrders, firePixelServer } = prevProps;
    const { location: { search: nextSearch } } = this.props;
    const prevParams = queryString.parse(prevSearch);
    const nextParams = queryString.parse(nextSearch);

    if (!deepEqual(prevParams, nextParams)) {
      fetchOrders(nextParams);
      firePixelServer('order-history');
    }
  }

  fetchData() {
    const { orders: { orders }, location: { search }, fetchOrders } = this.props;
    const queryParams = queryString.parse(search);

    if (!orders) {
      fetchOrders(queryParams, '/orders');
    }
  }

  render() {
    const { location, orders: { totalPages, orders, isLoading }, fetchOrders } = this.props;

    if (!orders || isLoading) {
      return <PageLoader centered={true}/>;
    } else {
      return (
        <div className={styles.orderHistory}>
          <div className={styles.header}>
            <Breadcrumb items={items}/>
            <BackNav to="/account">My Account</BackNav>
            <AccountHeader title="Order History"/>
          </div>
          <div className={styles.desktopOrderHistory}>
            <OrderHistoryOverview
              location={location}
              orders={orders}
              totalPages={totalPages}
              isLoading={isLoading}
              onFetchOrders={fetchOrders}/>
          </div>
          <div className={styles.mobileOrderHistory}>
            <OrderHistoryCardLayout
              location={location}
              orders={orders}
              totalPages={totalPages}/>
          </div>
        </div>
      );
    }
  }
}

OrderHistory.contextTypes = {
  testId: PropTypes.func
};

const mapStateToProps = state => ({
  orders: state.orders
});

export default connect(mapStateToProps, {
  fetchOrders,
  firePixelServer,
  checkCustomerAuthentication
})(OrderHistory);
